import React from 'react'
import styles from './index.module.css'

import HistoryIconPath from '../../../../assets/images/scanner/history.png'
import HistoryYellowIconPath from '../../../../assets/images/scanner/history-yellow.png'
import ScanIconPath from '../../../../assets/images/scanner/scan.png'
import ScanYellowIconPath from '../../../../assets/images/scanner/scan-yellow.png'
import KeyboardIconPath from '../../../../assets/images/scanner/keyboard.png'
import KeyboardYellowIconPath from '../../../../assets/images/scanner/keyboard-yellow.png'

import { useEditingDeviceName } from '../Common/TabPanel/DeviceName/useDeviceName'
import {useCurrentTab, TabName} from './useCurrentTab'

import { useShowValidationResult } from '../Common/ValidationResult/useShowValidationResult'

const {HistoryTab, ScanTab, ManualEnterTab} = TabName

const TabBar = () => {

  const {currentTab, setCurrentTab} = useCurrentTab()
  const {editingDeviceName} = useEditingDeviceName()
  const {showValidationResult} = useShowValidationResult()

  return (
    <>
      {!editingDeviceName && !showValidationResult &&
        <div className={styles.tabBar}>

          <button
            className={styles.tab}
            onClick={() => setCurrentTab(HistoryTab)}
          >
            <img
              className={styles.historyIcon}
              src={currentTab === HistoryTab ? HistoryYellowIconPath : HistoryIconPath}
            />
            <div className={styles.tabTitle}>History</div>
          </button>

          <button
            className={styles.tab}
            onClick={() => setCurrentTab(ScanTab)}
          >
            <img
              className={styles.scanIcon}
              src={currentTab === ScanTab ? ScanYellowIconPath : ScanIconPath}
            />
            <div className={styles.tabTitle}>Scan</div>
          </button>

          <button
            className={styles.tab}
            onClick={() => setCurrentTab(ManualEnterTab)}
          >
            <img
              className={styles.manualEnterIcon}
              src={currentTab === ManualEnterTab ? KeyboardYellowIconPath : KeyboardIconPath}
            />
            <div className={styles.tabTitle}>Manual Enter</div>
          </button>

        </div>
      }
    </>
  )

}

export default TabBar
